import React, { HTMLAttributes, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide, type SwiperClass } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Controller } from "swiper/modules";

import SlideComponentOne from './slideComponentOne';
import SlideComponentTwo from './slideComponentTwo';


export const HOW_TO_USE_COMPONENT = [
  <SlideComponentTwo />,
  <SlideComponentOne />,
];

export const PAGINATION_LIST = [
  {
    chinese_text: "免費泊車教學",
    english_text: "Free Parking Guide",
  },
  {
    chinese_text: "如何使用",
    english_text: "How to Use",
  },
 
];


interface IHowToUseSction {}

type THowToUseSctionProps = IHowToUseSction & HTMLAttributes<HTMLDivElement>;

const HowToUseSction: React.FC<THowToUseSctionProps> = (props) => {
  const { ...otherProps } = props;

  //@ts-ignore
   const [controlledSwiper, setControlledSwiper] = useState<SwiperClass>(null);
   const [activeIndex, setActiveIndex] = useState(0);

   const handleSlideChange = () => {
     setActiveIndex(controlledSwiper?.activeIndex || 0);
   };

   const CustomPagination = () => {
     return (
       <div className="flex flex-row justify-center items-center gap-10 mb-10">
         {PAGINATION_LIST.map((text, index) => {
           return (
             <React.Fragment key={index}>
               <div
                 className={`flex flex-col font-bold text-center cursor-pointer hover:text-mainYellow ${
                   activeIndex === index ? "text-white" : "text-secondaryDark"
                 }`}
                 onClick={() => controlledSwiper.slideTo(index)}
               >
                 <span className="text-base laptop:text-2xl">
                   {text.chinese_text}
                 </span>
                 <span className="text-sm laptop:text-base">
                   {text.english_text}
                 </span>
               </div>

               {/* Add a divider except after the last item */}
               {index < PAGINATION_LIST.length - 1 && (
                 <div className="w-[1px] h-full bg-gray-400"></div>
               )}
             </React.Fragment>
           );
         })}
       </div>
     );
   };

  return (
    <div
      className="max-w-full justify-center flex flex-col p-8 laptop:px-[10%]"
      {...otherProps}
    >
        <CustomPagination />
        <Swiper
          modules={[Controller]}
          controller={{ control: controlledSwiper }}
          onSwiper={setControlledSwiper}
          onSlideChange={handleSlideChange}
         className='w-full'
        >
          {HOW_TO_USE_COMPONENT.map((text, index) => {
            return (
              <SwiperSlide
                className="flex flex-row justify-center items-center text-mainYellow gap-6"
                key={index}
              >
                {text}
              </SwiperSlide>
            );
          })}
        </Swiper>
   
 
      {/* <PriceSection /> */}
    </div>
  );
};

export default HowToUseSction;
